import { server_connection } from 'config';
import * as DashboardActions from 'main/content/dashboard/store/actions';

export const GET_NOTIFICATIONS = '[NOTIFICATION APP] GET NOTIFICATIONS';
export const UPDATE_NOTIFICATION_LOADED = '[NOTIFICATION APP] UPDATE NOTIFICATION LOADED';
export const UPDATE_NOTIFICATION_FORM = '[NOTIFICATION APP] UPDATE NOTIFICATION FORM';
export const GET_NOTIFICATION = '[NOTIFICATION APP] GET NOTIFICATION';
export const SET_NOTIFICATION_REFERENCE = '[NOTIFICATION APP] SET NOTIFICATION REFERENCE';
export const AUTH_VIEW_NOTIFICATION = '[NOTIFICATION APP] AUTH VIEW NOTIFICATION';
export const GENERATE_NOTIFICATIONS = '[NOTIFICATION APP] GENERATE NOTIFICATIONS';
export const RESOLVE_NOTIFICATION = '[NOTIFCATION APP] RESOLVE NOTIFICATION';

export function updateNotificationLoaded(setting) {
    return {
        type: UPDATE_NOTIFICATION_LOADED,
        payload: setting
    }
}

export function updateNotificationForm(notification_data) {
    return {
        type: UPDATE_NOTIFICATION_FORM,
        payload: notification_data
    }
}

export function getNotification(notification_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/notification/get/' + notification_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_NOTIFICATION,
                    payload: data,
                });
            })
    }
}

export function getNotificationData(notification_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getNotification(notification_id)),
        ]).then(
            () => dispatch(updateNotificationLoaded(true))
        )
    }
}

export function getNotifications(auth) {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/notifications',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_NOTIFICATIONS,
                    payload: responseData,
                });
            });
    }
}

export function saveNotification(notification) {
    return (dispatch, getState) => {
        fetch(server_connection + '/notification/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ notification })
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (notification.NotificationType === 'scheduled_course') {
                    dispatch(DashboardActions.getInstructorCourseNotifications(notification.NotificationReferenceID))
                    // dispatch({
                    //     type: GET_NOTIFICATIONS,
                    //     payload: responseData,
                    // });
                }
            });
    }
}

export function deleteNotification(notification_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/notification/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ notification_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                // dispatch({
                //     type: GET_NOTIFICATIONS,
                //     payload: responseData,
                // });
            });
    }
}

export function setNotificationReference(data) {
    return {
        type: SET_NOTIFICATION_REFERENCE,
        payload: data
    }
}

export function authViewNotification(auth, notification_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/notification/view',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth, notification_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: AUTH_VIEW_NOTIFICATION,
                    payload: notification_id,
                });
            });
    }
}

export function generateNotifications(user) {
    return (dispatch, getState) => {
        fetch(server_connection + '/notification/generate',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ user })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GENERATE_NOTIFICATIONS,
                    payload: responseData,
                });
            });
    }
}

export function resolveNotification(notification_rel_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/notification/resolve',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ notification_rel_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: RESOLVE_NOTIFICATION,
                    payload: notification_rel_id,
                });
                dispatch(DashboardActions.removeResolvedNotification(notification_rel_id))
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/notification/store/actions/notification.actions.js